import React, { useState, useEffect } from "react";
import HeaderAdmin from "../../Components/HeaderAdmin/Header";
import { Accordion } from "react-bootstrap";
import { FaAngleUp } from "react-icons/fa";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Form } from "react-bootstrap";
import AccordionData from "./AccordionData";
import VideoUpload from "../DashboardComponents/ClubFitting Video view/VideoUpload";
import VideoUpload2 from "../DashboardComponents/ClubFitting Video view/VideoUpload2";
import { Link, useParams } from "react-router-dom";
import { IoClose, IoEye } from "react-icons/io5";
import { Modal } from "react-bootstrap";
import { getremoteInquirydataApi } from "../../Api/iron"
import { getCurrentUser } from "../../Api/auth";
import { deleteProjectApi, addnotes, getnotes } from "../../Api/prescriptionApis"
import Button from 'react-bootstrap/Button';
import { MdBookmarkAdd } from "react-icons/md";
import { ReactNotifications, Store } from 'react-notifications-component'
import { useHistory } from 'react-router-dom';
import { IoCloseSharp } from "react-icons/io5";
import { getPrescription } from "../../Api/prescriptionApis";
import Loader2 from "../DashboardComponents/Loader/Loader2";
import ClubFittingLeft from "./ClubFittingLeft";


function ClubFittingUpdate() {

    const history = useHistory();

    const goBack = () => {
        history.goBack();
    };

    const [validated, setValidated] = useState(false);
    const [firstvideo, setFirstVideo] = useState(null);
    const [secondvideo, setSecondVideo] = useState(null);
    const [apicall, setApicall] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const params = useParams();

    const initData = {
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        height_ft: "",
        height_in: "",
        wrist_to_floor: "",
        shoulder_to_wrist: "",
        elbow_to_wrist: ""
    };

    const [resultoutput, setResultoutput] = useState({
        white: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        black: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        blue: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        pink: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        purple: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        red: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        orange: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        green: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
    });

    const [formData, setFormData] = useState(initData);
    const [remotefittingdata, setRemotefittingdata] = useState([]);
    const [remotefittingimage, setRemotefittingimage] = useState([]);
    const [notesdata, setnotesData] = useState([]);
    const [prescriptionid, setPrescriptionid] = useState(null)

    const handleCloseConfirmation = () => setShowConfirmation(false);
    const handleShowConfirmation = () => setShowConfirmation(true);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [user_id, setUser_id] = useState(0);
    const [notes, setnotes] = useState('')

    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        // const handleScroll = () => {
        //     const scrollTop = window.scrollY;
        //     if (scrollTop > 50) {
        //         setScrolled(true);
        //     } else {
        //         setScrolled(false);
        //     }
        // };

        // window.addEventListener('scroll', handleScroll);
        // return () => {
        //     window.removeEventListener('scroll', handleScroll);
        // };
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    const getDataById = () => {
        setIsLoading(true);
        getremoteInquirydataApi({ id: params.id }).then((res) => {
            if (res?.code === 200) {
                const userData = res.data.data;
                setFormData(userData);
                setRemotefittingdata(userData.remotefittingdata);
                setRemotefittingimage(userData.remotefittingimage);
                // manageResult(userData.remotefittingdata);
                setPrescriptionid(userData.prescription._id)
            } else {
                // alert(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        }).finally(() => {
            setIsLoading(false);
        });
    }

    useEffect(() => {
        getDataById()
        handlegetnotes();
    }, [params])

    const options1 = [
        { id: 1, text: 'Pull Hook' },
        { id: 2, text: 'Pull Straight' },
        { id: 3, text: 'Pull Fade' },
        { id: 4, text: 'Straight' },
        { id: 5, text: 'Push Draw' },
        { id: 6, text: 'Push Strait' },
        { id: 7, text: 'Push Slice' },
    ];

    const options2 = [
        { id: 1, text: 'Pull Hook' },
        { id: 2, text: 'Pull Straight' },
        { id: 3, text: 'Pull Fade' },
        { id: 4, text: 'Straight' },
        { id: 5, text: 'Push Draw' },
        { id: 6, text: 'Push Strait' },
        { id: 7, text: 'Push Slice' },
    ];

    const options3 = [
        { id: 1, text: 'Pull Hook' },
        { id: 2, text: 'Pull Straight' },
        { id: 3, text: 'Pull Fade' },
        { id: 4, text: 'Straight' },
        { id: 5, text: 'Push Draw' },
        { id: 6, text: 'Push Strait' },
        { id: 7, text: 'Push Slice' },
    ];

    const shotOpction = [
        { id: 1, text: 'On Target' },
        { id: 2, text: 'Left Of Target' },
        { id: 2, text: 'Right Of Target' },
    ]

    const shortStrike = [
        { id: 1, text: 'Tiger Strike' },
        { id: 2, text: 'No Tiger Strike' },
    ]

    const deleteproject = () => {

        deleteProjectApi({ id: params.id }).then((res) => {
            if (res?.code === 200) {
                window.location.href = "/project/clubfitting";
            } else {
                alert(res?.message);
            }
        }).catch((err) => {
            alert(err);
        })

    }

    useEffect(() => {
        const getCurrentUserdata = getCurrentUser();
        // setUserdata(getCurrentUserdata.user);
        // setUser_id(getCurrentUserdata.user._id);


        if (getCurrentUserdata && getCurrentUserdata.user) {
            setUser_id(getCurrentUserdata.user._id);
        } else {
            console.error("Current user data is null or undefined");
        }
        getprojectdata();

    }, []);

    const [noteserror, setNoteserror] = useState(false);

    const handleaddnotes = () => {
        setApicall(true);

        if (notes === "") {
            setNoteserror(true);
            return false;
            // Store.addNotification({
            //     title: "Error",
            //     message: "Please enter notes",
            //     type: "danger",
            //     insert: "top",
            //     container: "top-right",
            //     animationIn: ["animated", "fadeIn"],
            //     animationOut: ["animated", "fadeOut"],
            //     dismiss: {
            //         duration: 3000,
            //         onScreen: true
            //     }
            // });
            // return false;
        }

        const data = {
            notes: notes,
            user_id: user_id,
            project_id: params.id
        }

        addnotes(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                // handleShow();
                getDataById();
                handlegetnotes();
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicall(false);
            setValidated(true);
            setnotes('');
            setNoteserror(false);
        });
    };

    const handlegetnotes = () => {
        setApicall(true);


        const data = {
            project_id: params.id
        }
        
        getnotes(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setnotesData(data);
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicall(false);
            setValidated(true);
            console.log("data", "2");
        });
    };

    // const manageResult = (result) => {

    //     const getwhitelabel = getLebel(result.step1);
    //     const getblacklabel = getLebel(result.step2);
    //     const getbluelabel = getLebel(result.step3);
    //     const getpinklabel = getLebel(result.step4);
    //     const getpurplelabel = getLebel(result.step5);
    //     const getredlabel = getLebel(result.step6);
    //     const getorangelabel = getLebel(result.step7);
    //     const getgreenlabel = getLebel(result.step8);

    //     setResultoutput({
    //         white: getwhitelabel,
    //         black: getblacklabel,
    //         blue: getbluelabel,
    //         pink: getpinklabel,
    //         purple: getpurplelabel,
    //         red: getredlabel,
    //         orange: getorangelabel,
    //         green: getgreenlabel,

    //     });
    // }

    // useEffect(() => {

    // }, [resultoutput]);


    // const getLebel = (step) => {

    //     var lowestIron = 0;
    //     var bestLabel = "";
    //     var bestposition = 1;
    //     const iron1_shot1 = parseInt(step.iron1.shot1.optionx_value) + parseInt(step.iron1.shot1.optiony_value) + parseInt(step.iron1.shot1.option1_value) + parseInt(step.iron1.shot1.option2_value);
    //     const iron1_shot2 = parseInt(step.iron1.shot2.optionx_value) + parseInt(step.iron1.shot2.optiony_value) + parseInt(step.iron1.shot2.option1_value) + parseInt(step.iron1.shot2.option2_value);
    //     const iron1_shot3 = parseInt(step.iron1.shot3.optionx_value) + parseInt(step.iron1.shot3.optiony_value) + parseInt(step.iron1.shot3.option1_value) + parseInt(step.iron1.shot3.option2_value);

    //     const iron2_shot1 = parseInt(step.iron2.shot1.optionx_value) + parseInt(step.iron2.shot1.optiony_value) + parseInt(step.iron2.shot1.option1_value) + parseInt(step.iron2.shot1.option2_value);
    //     const iron2_shot2 = parseInt(step.iron2.shot2.optionx_value) + parseInt(step.iron2.shot2.optiony_value) + parseInt(step.iron2.shot2.option1_value) + parseInt(step.iron2.shot2.option2_value);
    //     const iron2_shot3 = parseInt(step.iron2.shot3.optionx_value) + parseInt(step.iron2.shot3.optiony_value) + parseInt(step.iron2.shot3.option1_value) + parseInt(step.iron2.shot3.option2_value);

    //     const iron3_shot1 = parseInt(step.iron3.shot1.optionx_value) + parseInt(step.iron3.shot1.optiony_value) + parseInt(step.iron3.shot1.option1_value) + parseInt(step.iron3.shot1.option2_value);
    //     const iron3_shot2 = parseInt(step.iron3.shot2.optionx_value) + parseInt(step.iron3.shot2.optiony_value) + parseInt(step.iron3.shot2.option1_value) + parseInt(step.iron3.shot2.option2_value);
    //     const iron3_shot3 = parseInt(step.iron3.shot3.optionx_value) + parseInt(step.iron3.shot3.optiony_value) + parseInt(step.iron3.shot3.option1_value) + parseInt(step.iron3.shot3.option2_value);


    //     const iron1 = iron1_shot1 + iron1_shot2 + iron1_shot3;
    //     const iron2 = iron2_shot1 + iron2_shot2 + iron2_shot3;
    //     const iron3 = iron3_shot1 + iron3_shot2 + iron3_shot3;
    

    //     if (iron1 <= iron2 && iron1 <= iron3) {
    //         lowestIron = 1;
    //     }
    //     else if (iron2 <= iron1 && iron2 <= iron3) {
    //         lowestIron = 2;
    //     }
    //     else if (iron3 <= iron1 && iron3 <= iron2) {
    //         lowestIron = 3;
    //     }
    //     else {
    //         lowestIron = 1;
    //     }


    //     if (step.name == "white Irons") {
    //         console.log("aminesh babu", iron1, iron2, iron3, lowestIron);
    //         if (lowestIron == 1) {
    //             bestLabel = "Low";
    //             bestposition = 1;
    //         } else if (lowestIron == 2) {
    //             bestLabel = "Mid";
    //             bestposition = 2;
    //         } else if (lowestIron == 3) {
    //             bestLabel = "High";
    //             bestposition = 3;
    //         }
    //     }

    //     if (step.name == "Black Irons") {
    //         if (lowestIron == 1) {
    //             bestLabel = "Upright";
    //             bestposition = 1;
    //         } else if (lowestIron == 2) {
    //             bestLabel = "Standard";
    //             bestposition = 2;
    //         } else if (lowestIron == 3) {
    //             bestLabel = "Flat";
    //             bestposition = 3;
    //         }
    //     }

    //     if (step.name == "Blue Irons") {
    //         console.log("white Irons lowestIron", iron1, iron2, iron3);
    //         if (lowestIron == 1) {
    //             bestLabel = "Heavy";
    //             bestposition = 1;
    //         } else if (lowestIron == 2) {
    //             bestLabel = "Medium";
    //             bestposition = 2;
    //         } else if (lowestIron == 3) {
    //             bestLabel = "Light";
    //             bestposition = 3;
    //         }
    //     }

    //     if (step.name == "Pink Irons") {
    //         if (lowestIron == 1) {
    //             bestLabel = "Hard";
    //             bestposition = 1;
    //         } else if (lowestIron == 2) {
    //             bestLabel = "Medium";
    //             bestposition = 2;
    //         } else if (lowestIron == 3) {
    //             bestLabel = "Soft";
    //             bestposition = 3;
    //         }
    //     }

    //     if (step.name == "Purple Irons") {
    //         if (lowestIron == 1) {
    //             bestLabel = "Firm Tip";
    //             bestposition = 1;
    //         } else if (lowestIron == 2) {
    //             bestLabel = "Soft Mid";
    //             bestposition = 2;
    //         } else if (lowestIron == 3) {
    //             bestLabel = "Firm Butt";
    //             bestposition = 3;
    //         }
    //     }

    //     if (step.name == "Red Irons") {
    //         if (lowestIron == 1) {
    //             bestLabel = "Oversize";
    //             bestposition = 1;
    //         } else if (lowestIron == 2) {
    //             bestLabel = "Mid";
    //             bestposition = 2;
    //         } else if (lowestIron == 3) {
    //             bestLabel = "Standard";
    //             bestposition = 3;
    //         }
    //     }

    //     if (step.name == "Orange Irons") {
    //         if (lowestIron == 1) {
    //             bestLabel = "Long";
    //             bestposition = 1;
    //         } else if (lowestIron == 2) {
    //             bestLabel = "Medium";
    //             bestposition = 2;
    //         } else if (lowestIron == 3) {
    //             bestLabel = "Short";
    //             bestposition = 3;
    //         }
    //     }

    //     if (step.name == "Green Irons") {
    //         if (lowestIron == 1) {
    //             bestLabel = "Heavy";
    //             bestposition = 1;
    //         } else if (lowestIron == 2) {
    //             bestLabel = "Medium";
    //             bestposition = 2;
    //         } else if (lowestIron == 3) {
    //             bestLabel = "Light";
    //             bestposition = 3;
    //         }
    //     }
    //     return { iron1: iron1, iron2: iron2, iron3: iron3, label: bestLabel, bestposition: bestposition };
    // }

    const getprojectdata = () => {
        // setApicall(true);
        // const data = {
        //     'project_id': params.id
        // }
        // getPrescription(data).then((res) => {
        //     console.log("res", res);
        //     if (!res.data.status) {
        //         alert(res.data.data[0].detail);
        //     } else {
        //         setApicall(false);
        //         setPrescriptionid(res.data.data._id)
        //     }

        // }).catch((error) => {
        //     console.log("error", error);
        // });
    }


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    const [isTabVisible, setIsTabVisible] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 991) {
                setIsTabVisible(true);
            } else {
                setIsTabVisible(false);
            }
        };

        // Set the initial state
        handleResize();

        // Add event listener for window resize
        window.addEventListener('resize', handleResize);

        // Cleanup event listener on component unmount
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    return (
        <>
            {
                isLoading ? (
                    <div className="loading">
                        <Loader2 />
                    </div>
                ) : (
                    <>
                        <ReactNotifications />

                        <Modal
                            show={showConfirmation}
                            onHide={handleCloseConfirmation}
                            centered
                            id="success_tic"
                            className='model-thank-you'
                        >
                            <Modal.Body>
                                <div className="logo-modal mb-4 text-center">
                                    <img src={require('../../assets/images/logo_text.png')} alt="logo" />
                                </div>
                                <div className="confirmation-content text-center">
                                    <h4>Are you sure you want to remove this Project?</h4>
                                    <div className="confirmation-buttons mt-4">
                                        <Button variant="danger" onClick={deleteproject}>
                                            Yes
                                        </Button>
                                        {' '}
                                        <Button variant="secondary" onClick={handleCloseConfirmation}>
                                            No
                                        </Button>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>

                        <Modal size="lg" centered show={show} onHide={handleClose} className="card-radius popup-modal-dark add_club_modal">
                            <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                                <div className="close-modal">
                                    <div className="custom-modal-header">
                                        <h3 className="text mb-5">Golf Swing</h3>
                                        <button type="button" className="btn-close" onClick={handleClose} aria-label="Close">
                                            <IoClose />
                                        </button>
                                    </div>
                                </div>
                                <div className='modal-long-form'>
                                    <div className="irons-content">
                                        <div className="sec-header-dash club-fitting-card-header">
                                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                                <h3 className="box-title-lable">
                                                    Getting Started
                                                </h3>
                                            </div>
                                        </div>
                                        <div className="dashboard-sec">
                                            <div className="container-fulid">
                                                <Form noValidate validated={validated}>
                                                    <div className="club_fitting_box_section follow-view-form mt-4">
                                                        <div className="form-box-inner">
                                                            <div className="form-item">
                                                                <div className="form-group custom-form-group">
                                                                    <label className="dashboard-form-lable">Name</label>
                                                                    <div className="followup-name-view">
                                                                        <input type="text"
                                                                            required
                                                                            value={formData.firstname}
                                                                            disabled
                                                                            className={`form-control dashboard-input-box-2 me-1`}
                                                                            placeholder="First"
                                                                            name={"firstname"}
                                                                        />
                                                                        <input type="text"
                                                                            required
                                                                            disabled
                                                                            value={formData.lastname}
                                                                            className={`form-control dashboard-input-box-2 `}
                                                                            placeholder="Last"
                                                                            name={"lastname"}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="form-item">
                                                                <div className="form-group custom-form-group">
                                                                    <Form.Label className="dashboard-form-lable">Email</Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        className={`form-control dashboard-input-box-2`}
                                                                        placeholder="Email Address"
                                                                        name="email"
                                                                        disabled
                                                                        value={formData.email}
                                                                        required />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        Please enter valid email
                                                                    </Form.Control.Feedback>
                                                                </div>
                                                            </div>
                                                            <div className="form-item">
                                                                <div className="form-group custom-form-group">
                                                                    <label className="dashboard-form-lable">Phone</label>
                                                                    <input type="text" name={"phone"}
                                                                        disabled
                                                                        value={formData.phone}
                                                                        className={`form-control dashboard-input-box-2 `}
                                                                        placeholder="Phone Number" />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        Please enter phone number
                                                                    </Form.Control.Feedback>
                                                                </div>
                                                            </div>
                                                            <div className="form-item" style={{ display: 'none' }}>
                                                                <div className="form-group custom-form-group">
                                                                    <label className="dashboard-form-lable">Wrist to Floor</label>
                                                                    <input type="text" className="form-control dashboard-input-box w-18" name={"wrist_to_floor"} placeholder="in." />
                                                                </div>
                                                            </div>
                                                            <div className="form-item" style={{ display: 'none' }}>
                                                                <div className="form-group custom-form-group">
                                                                    <label className="dashboard-form-lable">Shoulder to Wrist</label>
                                                                    <input type="text" className="form-control dashboard-input-box w-18" name={"shoulder_to_wrist"} placeholder="in." />
                                                                </div>
                                                            </div>
                                                            <div className="form-item" style={{ display: 'none' }}>
                                                                <div className="form-group custom-form-group">
                                                                    <label className="dashboard-form-lable">Elbow to Wrist</label>
                                                                    <input type="text" className="form-control dashboard-input-box w-18" name={"elbow_to_wrist"} placeholder="in." />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Form>
                                            </div>
                                        </div>
                                        <div className="sec-header-dash club-fitting-card-header">
                                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                                <h3 className="box-title-lable">
                                                    Your Height
                                                </h3>
                                            </div>
                                        </div>
                                        <div class="dashboard-sec">
                                            <div className="club_fitting_box_section mt-4">
                                                <div className="form-item height-form-iteam">
                                                    <div className="form-group custom-form-group mb-0">
                                                        <label className="dashboard-form-lable">Height</label>
                                                        <div className="d-flex justify-content-end gap-2 align-items-center w-100">
                                                            <select class="form-select form-control dashboard-input-box-3 select-custom-boxx w-25" disabled aria-label="Default select example">
                                                                <option value={0}>ft.</option>
                                                                <option value="4">4 ft.</option>
                                                                <option value="5">5 ft.</option>
                                                                <option value="6">6 ft.</option>
                                                                <option value="7">7 ft.</option>
                                                            </select>
                                                            <select class="form-select form-control dashboard-input-box-3 select-custom-boxx w-25" disabled aria-label="Default select example">
                                                                <option value={0}>in.</option>
                                                                <option value="1">0 in.</option>
                                                                <option value="2">1 in.</option>
                                                                <option value="3">2 in.</option>
                                                                <option value="4">3 in.</option>
                                                                <option value="5">4 in.</option>
                                                                <option value="6">5 in.</option>
                                                                <option value="7">6 in.</option>
                                                                <option value="8">7 in.</option>
                                                                <option value="9">8 in.</option>
                                                                <option value="10">9 in.</option>
                                                                <option value="11">10 in.</option>
                                                                <option value="12">11 in.</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="sec-header-dash club-fitting-card-header">
                                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                                <h3 className="box-title-lable">
                                                    Your Dexterity
                                                </h3>
                                            </div>
                                        </div>
                                        <div class="dashboard-sec">
                                            <div className="club_fitting_box_section mt-4">
                                                <div className="form-item height-form-iteam">
                                                    <div className="form-group custom-form-group mb-0">
                                                        <label className="dashboard-form-lable">Dexterity</label>
                                                        <div className="d-flex justify-content-end gap-2 align-items-center w-100">
                                                            <select required class="form-select form-control dashboard-input-box-3 select-custom-boxx w-25" disabled aria-label="Default select example">
                                                                <option value={0}>Dexterity</option>
                                                                <option value="1">Right Handed</option>
                                                                <option value="2">Left Handed</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="sec-header-dash club-fitting-card-header">
                                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                                <h3 className="box-title-lable">
                                                    Your Swing
                                                </h3>
                                            </div>
                                        </div>
                                        <div class="dashboard-sec">
                                            <div className="club_fitting_box_section mt-4">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="d-flex justify-content-center gap-2">
                                                            <VideoUpload step="step0" onfilechange={(editfile) => setFirstVideo(editfile)} remotefittingimage={remotefittingimage} />
                                                            <VideoUpload2 step="step0" onfilechange={(editfile) => setSecondVideo(editfile)} remotefittingimage={remotefittingimage} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>

                        <div className="main-page-body-content-header">
                            <HeaderAdmin />
                        </div>

                        <div className='design_show_mobile'>
                            <div className='fixed-btn'>
                                <Link to={`/create-prescription?id=${formData._id}`}>
                                    <svg fill="none" height="64" viewBox="0 0 64 64" width="64" xmlns="http://www.w3.org/2000/svg"><g fill="#262a31"><path d="m24 2c-3.866 0-7 3.13401-7 7 0 3.866 3.134 7 7 7h14c3.866 0 7-3.134 7-7 0-3.86599-3.134-7-7-7z" /><g clip-rule="evenodd" fill-rule="evenodd"><path d="m14.4096 6.15808c-.2665.90082-.4096 1.85466-.4096 2.84191 0 5.52281 4.4772 10.00001 10 10.00001h14c5.5229 0 10-4.4772 10-10.00001 0-.98725-.1431-1.94109-.4096-2.84191 3.6564.73752 6.4096 3.96822 6.4096 7.84192v22.2481c-1.8374-.8028-3.8667-1.2481-6-1.2481-8.2843 0-15 6.7157-15 15 0 2.9412.8465 5.6846 2.3091 8h-19.3091c-4.4183 0-8-3.5817-8-8v-36c0-3.8737 2.7532-7.1044 6.4096-7.84192zm3.5904 19.84192c0-1.1046.8954-2 2-2h24c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-24c-1.1046 0-2-.8954-2-2zm2 6c-1.1046 0-2 .8954-2 2s.8954 2 2 2h14c1.1046 0 2-.8954 2-2s-.8954-2-2-2zm-2 10c0-1.1046.8954-2 2-2h10c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-10c-1.1046 0-2-.8954-2-2z" /><path d="m48 38c-6.6274 0-12 5.3726-12 12s5.3726 12 12 12 12-5.3726 12-12-5.3726-12-12-12zm0 18.0004c-1.1046 0-2-.8955-2-2v-2.0003h-2c-1.1046 0-2-.8954-2-2 0-1.1045.8954-2 2-2h2v-1.9997c0-1.1046.8954-2 2-2s2 .8954 2 2v1.9997h2c1.1046 0 2 .8955 2 2 0 1.1046-.8954 2-2 2h-2v2.0003c0 1.1045-.8954 2-2 2z" /></g></g></svg>
                                </Link>
                            </div>
                        </div>

                        <div className="dashboard-container d-flex dashboard_light build_box_dashboard_sec">
                            <div className="main-container">
                                <div className="main-page-body-content">
                                    <div className="main-page-body-content-body">
                                        <div className="main-page-body-content-body-container">
                                            <div className="container-fluid">
                                                <div className="sec-header-new">
                                                    <button type="button" className="btn-header-transparent">
                                                        <div className="border_box_view">
                                                            <div className="border_box_view_inner">
                                                                <div className="box_icon">
                                                                    <svg fill="none" height="64" viewBox="0 0 64 64" width="64" xmlns="http://www.w3.org/2000/svg"><g fill="#99ea24"><path d="m25 2c-3.866 0-7 3.13401-7 7 0 3.866 3.134 7 7 7h14c3.866 0 7-3.134 7-7 0-3.86599-3.134-7-7-7z" /><path clip-rule="evenodd" d="m15 9.00001c0-.6707.066-1.32598.1919-1.9597-4.0388.40511-7.1919 3.81419-7.1919 7.95969v39c0 4.4183 3.5817 8 8 8h32c4.4183 0 8-3.5817 8-8v-39c0-4.1455-3.1531-7.55458-7.1919-7.95968.1259.63371.1919 1.28899.1919 1.95969 0 5.52289-4.4771 9.99999-10 9.99999h-14c-5.5228 0-10-4.4771-10-9.99999zm13.4142 18.58579c.7811.781.7811 2.0474 0 2.8284l-6 6c-.432.4321-1.0379.6429-1.6448.5725-.6069-.0705-1.1483-.4145-1.4699-.934l-2-3.2308c-.5814-.9391-.2914-2.1718.6478-2.7532s2.1718-.2913 2.7532.6478l.6709 1.0837 4.2144-4.2144c.781-.7811 2.0474-.7811 2.8284 0zm6.5858 1.4142c-1.1046 0-2 .8954-2 2s.8954 2 2 2h10c1.1046 0 2-.8954 2-2s-.8954-2-2-2zm-2 15c0-1.1046.8954-2 2-2h10c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-10c-1.1046 0-2-.8954-2-2zm-4.5858.4142c.7811-.781.7811-2.0474 0-2.8284-.781-.7811-2.0474-.7811-2.8284 0l-4.2144 4.2144-.6709-1.0837c-.5814-.9391-1.814-1.2292-2.7532-.6478s-1.2292 1.8141-.6478 2.7532l2 3.2308c.3216.5195.863.8635 1.4699.934.6069.0704 1.2128-.1404 1.6448-.5725z" fill-rule="evenodd" /></g></svg>
                                                                </div>
                                                                <div className="box_text_content">
                                                                    <div className="big_text">Fitting</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </button>
                                                    <div className="header-left">
                                                        <Link to={`/project/project-view/${params.id}`}>
                                                            <button type="button" className="btn-header-transparent me-3">
                                                                <div className="border_box_view">
                                                                    <div className="border_box_view_inner">
                                                                        <div className="box_icon">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" clip-rule="evenodd" fill-rule="evenodd" height="512" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" width="512"><g id="Icon" fill='#99ea24'><path d="m15.479 22.75h-11.479c-.729 0-1.429-.29-1.945-.805-.515-.516-.805-1.216-.805-1.945v-16c0-.729.29-1.429.805-1.945.516-.515 1.216-.805 1.945-.805h8.586c.464 0 .909.184 1.237.513l4.414 4.414c.329.328.513.773.513 1.237v4.151c-.687-.101-1.386-.084-2.068.05-.575.112-1.055.505-1.28 1.046l-.17.41c-.224-.029-.441-.057-.441-.057-.581-.076-1.161.143-1.546.585-.521.598-.922 1.291-1.179 2.042-.19.554-.09 1.166.266 1.631l.271.353c-.137.179-.271.353-.271.353-.356.465-.456 1.077-.266 1.631.257.751.658 1.444 1.179 2.042.385.442.965.661 1.546.585l.441-.057c.086.208.17.41.17.41.023.055.049.109.077.161zm-9.979-8h4.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-4.5c-.414 0-.75.336-.75.75s.336.75.75.75zm7-11.75v3.5c0 .552.448 1 1 1h3.5zm-7 8.25h8c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-8c-.414 0-.75.336-.75.75s.336.75.75.75zm0 7h4.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-4.5c-.414 0-.75.336-.75.75s.336.75.75.75z"/><path d="m19.396 13.044s.355.855.354.855c.135.068.266.144.393.226l.918-.12c.248-.032.497.062.662.251.436.5.771 1.081.987 1.709.081.237.038.5-.115.699 0 0-.562.735-.562.734.008.151.008.303 0 .453l.562.735c.153.199.196.462.115.699-.216.628-.551 1.209-.987 1.709-.165.189-.414.283-.662.251 0 0-.918-.12-.917-.121-.127.083-.259.159-.393.227l-.355.855c-.096.232-.302.4-.548.448-.652.128-1.322.128-1.974 0-.246-.048-.452-.216-.548-.448 0 0-.355-.855-.354-.855-.135-.068-.267-.144-.393-.226l-.918.12c-.249.032-.497-.062-.662-.251-.437-.5-.772-1.081-.987-1.709-.081-.237-.038-.5.114-.699 0 0 .563-.735.563-.734-.008-.151-.008-.303 0-.453l-.563-.735c-.152-.199-.195-.462-.114-.699.215-.628.55-1.209.987-1.709.165-.189.413-.283.662-.251 0 0 .918.12.917.121.127-.083.258-.159.393-.227l.355-.855c.096-.232.302-.4.548-.448.652-.128 1.322-.128 1.974 0 .246.048.452.216.548.448zm-1.535 3.081c-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5 1.5-.672 1.5-1.5-.672-1.5-1.5-1.5z"/></g></svg>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </button>
                                                        </Link>
                                                        <button type="button" className="btn-header-transparent close-icon" onClick={goBack}>
                                                            <div className="border_box_view">
                                                                <div className="border_box_view_inner">
                                                                    <div className="box_icon">
                                                                        <IoCloseSharp />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="dashboard-sec">
                                                    <div className="row">
                                                        <div className="col-lg-8 col-md-12 col-sm-12 order-md-2 order-sm-2 order-2 dashboard_2 study_guide_open db_col design_hide_mobile">
                                                            <ClubFittingLeft notesdata={notesdata} prescription={prescriptionid}  formDatauser={formData} remotefittingimageimges={remotefittingimage} remotefittingdataofdata={remotefittingdata}/>
                                                        </div>
                                                        <div className={`col-lg-4 col-md-12 col-sm-12 order-md-1 order-sm-1 order-1 dashboard_first right_fix_sec ${scrolled ? 'tab_fix' : ''}`}>
                                                            <div className="fix_sec_view container-fluid ps-0">
                                                                <div className="btn-box-section mt-0 design_hide_mobile">
                                                                    <button className="btn btn-primary btn-create">
                                                                        <Link to={`/create-prescription?id=${formData._id}`}>
                                                                            <>
                                                                                {prescriptionid !== undefined && prescriptionid !== null ? (
                                                                                    'View Prescription'
                                                                                ) : (
                                                                                    'Create Prescription'
                                                                                )}
                                                                            </>
                                                                        </Link>
                                                                    </button>
                                                                </div>
                                                                <div className="tab-container tab-club-fitting design_hide_mobile">
                                                                    <Tabs
                                                                        defaultActiveKey="client"
                                                                        id="uncontrolled-tab-example"
                                                                        className="club-fitting-tab club_new_tab new_mobile_tab tab-wrapper"
                                                                    >
                                                                        <Tab eventKey="client" title="Client">
                                                                            <div className="tab-box-section">
                                                                                <Form noValidate validated={validated}>
                                                                                    <div className="row gx-2">
                                                                                        <div className="col-md-6 form-group" controlid="validationCustom01">
                                                                                            <input type="text" name="f-name" disabled value={formData.firstname} className="form-control dashboard-input-box-3" placeholder="First name" required />
                                                                                            <Form.Control.Feedback type="invalid">
                                                                                                Please enter a first name.
                                                                                            </Form.Control.Feedback>
                                                                                        </div>
                                                                                        <div className="col-md-6 form-group" controlid="validationCustom02">
                                                                                            <input type="text" name="l-name" disabled value={formData.lastname} className="form-control dashboard-input-box-3" placeholder="Last name" required />
                                                                                            <Form.Control.Feedback type="invalid">
                                                                                                Please enter a last name.
                                                                                            </Form.Control.Feedback>
                                                                                        </div>
                                                                                        <div className="col-6 col-md-3 form-group" controlid="validationCustom01">
                                                                                            <select disabled value={formData.height_ft} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                                                <option value={0}>ft.</option>
                                                                                                <option value="4">4 ft.</option>
                                                                                                <option value="5">5 ft.</option>
                                                                                                <option value="6">6 ft.</option>
                                                                                                <option value="7">7 ft.</option>
                                                                                            </select>
                                                                                            <Form.Control.Feedback type="invalid">
                                                                                                Please select a ft.
                                                                                            </Form.Control.Feedback>
                                                                                        </div>
                                                                                        <div className="col-6 col-md-3 form-group" controlid="validationCustom01">
                                                                                            <select disabled value={formData.height_in} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                                                <option value={0}>in.</option>
                                                                                                <option value="1">0 in.</option>
                                                                                                <option value="2">1 in.</option>
                                                                                                <option value="3">2 in.</option>
                                                                                                <option value="4">3 in.</option>
                                                                                                <option value="5">4 in.</option>
                                                                                                <option value="6">5 in.</option>
                                                                                                <option value="7">6 in.</option>
                                                                                                <option value="8">7 in.</option>
                                                                                                <option value="9">8 in.</option>
                                                                                                <option value="10">9 in.</option>
                                                                                                <option value="11">10 in.</option>
                                                                                                <option value="12">11 in.</option>
                                                                                            </select>
                                                                                            <Form.Control.Feedback type="invalid">
                                                                                                Please select a in.
                                                                                            </Form.Control.Feedback>
                                                                                        </div>
                                                                                        <div className="col-12 col-md-6 form-group" controlid="validationCustom01">
                                                                                            <select disabled value={formData.dexterity} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                                                <option value={0}>Dexterity</option>
                                                                                                <option value="1">Right Handed</option>
                                                                                                <option value="2">Left Handed</option>
                                                                                            </select>
                                                                                            <Form.Control.Feedback type="invalid">
                                                                                                Please select a Dexterity
                                                                                            </Form.Control.Feedback>
                                                                                        </div>
                                                                                        <div className="col-md-12 form-group" controlid="validationCustom03">
                                                                                            <input disabled value={formData.phone} type="tel" name="name" pattern="[0-9]{8,}" title="Please enter a 8-digit phone number." className="form-control dashboard-input-box-3" placeholder="Phone" required />
                                                                                            <Form.Control.Feedback type="invalid">
                                                                                                Please enter a 8-digit phone number.
                                                                                            </Form.Control.Feedback>
                                                                                        </div>
                                                                                        <div className="col-md-12 form-group" controlid="validationCustom04">
                                                                                            <input disabled value={formData.email} type="email" className="form-control dashboard-input-box-3" name="email" placeholder="Email" required />
                                                                                            <Form.Control.Feedback type="invalid">
                                                                                                Please choose a email.
                                                                                            </Form.Control.Feedback>
                                                                                        </div>
                                                                                        <div className="col-md-12 form-group" controlid="validationCustom04">
                                                                                            <input disabled value={formData.address} type="text" className="form-control dashboard-input-box-3" name="address" placeholder="Street Address, Apt. #" required />
                                                                                            <Form.Control.Feedback type="invalid">
                                                                                                Please choose a street address.
                                                                                            </Form.Control.Feedback>
                                                                                        </div>
                                                                                        <div className="col-4 col-md-6 form-group mb-0" controlid="validationCustom01">
                                                                                            <input type="text" disabled value={formData.city} name="f-name" className="form-control dashboard-input-box-3" placeholder="City" required />
                                                                                            <Form.Control.Feedback type="invalid">
                                                                                                Please enter City
                                                                                            </Form.Control.Feedback>
                                                                                        </div>
                                                                                        <div className="col-4 col-md-3 form-group mb-0" controlid="validationCustom02">
                                                                                            <input type="text" disabled value={formData.state} name="l-name" className="form-control dashboard-input-box-3" placeholder="State" required />
                                                                                            <Form.Control.Feedback type="invalid">
                                                                                                Please enter State
                                                                                            </Form.Control.Feedback>
                                                                                        </div>
                                                                                        <div className="col-4 col-md-3 form-group mb-0" controlid="validationCustom02">
                                                                                            <input type="text" disabled value={formData.zip} name="l-name" className="form-control dashboard-input-box-3" placeholder="Zip Code" required />
                                                                                            <Form.Control.Feedback type="invalid">
                                                                                                Please enter Zip Code
                                                                                            </Form.Control.Feedback>
                                                                                        </div>
                                                                                    </div>
                                                                                </Form>
                                                                            </div>
                                                                        </Tab>

                                                                        {isTabVisible && (
                                                                            <Tab eventKey="results" title="Results">
                                                                                <ClubFittingLeft  notesdata={notesdata} prescription={prescriptionid}  formDatauser={formData} remotefittingimageimges={remotefittingimage} remotefittingdataofdata={remotefittingdata}/>
                                                                            </Tab>
                                                                        )}

                                                                        <Tab eventKey="notes" title="Notes">
                                                                            <div className="tab-box-section notes-tab">
                                                                                <div className="form-group">
                                                                                    <textarea value={notes} onChange={(e) => setnotes(e.target.value)} className="dashboard-text-area" id="exampleFormControlTextarea1" rows="10" placeholder="Leave your note here..." ></textarea>
                                                                                    {
                                                                                        noteserror ? (
                                                                                            <div className="error-msg" style={{color:'red'}}>Please enter notes</div>
                                                                                        ) : null
                                                                                    }
                                                                                </div>
                                                                                <div className='text-center'>
                                                                                    <button className="btn btn-create" onClick={handleaddnotes} >Add Note</button>
                                                                                </div>
                                                                            </div>
                                                                            <>
                                                                                {
                                                                                    notesdata.length === 0 ? (
                                                                                        <div className="tab-box-section notes-tab mt-4">
                                                                                            <div className='no-data-img'>
                                                                                                <img src={require("../../assets/images/logo_text.png")} alt="" />
                                                                                            </div>
                                                                                            <div className="no-data-text">
                                                                                                <h3>No data Found</h3>
                                                                                            </div>
                                                                                        </div>
                                                                                    )
                                                                                        :
                                                                                        notesdata.map((item, i) => {
                                                                                            return (
                                                                                                <div className="dashboard-sec new_activity">
                                                                                                    <div className="form-box-section activity-form-box">
                                                                                                        <div className="form-list-inner">
                                                                                                            <div className="form-list-title activity-title">
                                                                                                                <div className="emp-name">
                                                                                                                    <div className="emp-light">Employee:</div>

                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div className="form-card-body-status">
                                                                                                                {item.notes}
                                                                                                            </div>
                                                                                                            <div className="form-change-date">Date: <span className="emp-bold">{item && formatDate(item.createdAt)}</span></div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            )
                                                                                        })
                                                                                }
                                                                            </>
                                                                        </Tab>
                                                                    </Tabs>
                                                                </div>

                                                                <div className="tab-container tab-club-fitting design_show_mobile">
                                                                    <Tabs
                                                                        defaultActiveKey="results"
                                                                        id="uncontrolled-tab-example"
                                                                        className="club-fitting-tab club_new_tab new_mobile_tab tab-wrapper"
                                                                    >
                                                                        <Tab eventKey="results" title="Results">
                                                                            <ClubFittingLeft  notesdata={notesdata} prescription={prescriptionid} formDatauser={formData} remotefittingimageimges={remotefittingimage} remotefittingdataofdata={remotefittingdata}/>
                                                                        </Tab>
                                                                        <Tab eventKey="client" title="Client">
                                                                            <div className="tab-box-section">
                                                                                <Form noValidate validated={validated}>
                                                                                    <div className="row gx-2">
                                                                                        <div className="col-md-6 form-group" controlid="validationCustom01">
                                                                                            <input type="text" name="f-name" disabled value={formData.firstname} className="form-control dashboard-input-box-3" placeholder="First name" required />
                                                                                            <Form.Control.Feedback type="invalid">
                                                                                                Please enter a first name.
                                                                                            </Form.Control.Feedback>
                                                                                        </div>
                                                                                        <div className="col-md-6 form-group" controlid="validationCustom02">
                                                                                            <input type="text" name="l-name" disabled value={formData.lastname} className="form-control dashboard-input-box-3" placeholder="Last name" required />
                                                                                            <Form.Control.Feedback type="invalid">
                                                                                                Please enter a last name.
                                                                                            </Form.Control.Feedback>
                                                                                        </div>
                                                                                        <div className="col-6 col-md-3 form-group" controlid="validationCustom01">
                                                                                            <select disabled value={formData.height_ft} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                                                <option value={0}>ft.</option>
                                                                                                <option value="4">4 ft.</option>
                                                                                                <option value="5">5 ft.</option>
                                                                                                <option value="6">6 ft.</option>
                                                                                                <option value="7">7 ft.</option>
                                                                                            </select>
                                                                                            <Form.Control.Feedback type="invalid">
                                                                                                Please select a ft.
                                                                                            </Form.Control.Feedback>
                                                                                        </div>
                                                                                        <div className="col-6 col-md-3 form-group" controlid="validationCustom01">
                                                                                            <select disabled value={formData.height_in} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                                                <option value={0}>in.</option>
                                                                                                <option value="1">0 in.</option>
                                                                                                <option value="2">1 in.</option>
                                                                                                <option value="3">2 in.</option>
                                                                                                <option value="4">3 in.</option>
                                                                                                <option value="5">4 in.</option>
                                                                                                <option value="6">5 in.</option>
                                                                                                <option value="7">6 in.</option>
                                                                                                <option value="8">7 in.</option>
                                                                                                <option value="9">8 in.</option>
                                                                                                <option value="10">9 in.</option>
                                                                                                <option value="11">10 in.</option>
                                                                                                <option value="12">11 in.</option>
                                                                                            </select>
                                                                                            <Form.Control.Feedback type="invalid">
                                                                                                Please select a in.
                                                                                            </Form.Control.Feedback>
                                                                                        </div>
                                                                                        <div className="col-12 col-md-6 form-group" controlid="validationCustom01">
                                                                                            <select disabled value={formData.dexterity} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                                                <option value={0}>Dexterity</option>
                                                                                                <option value="1">Right Handed</option>
                                                                                                <option value="2">Left Handed</option>
                                                                                            </select>
                                                                                            <Form.Control.Feedback type="invalid">
                                                                                                Please select a Dexterity
                                                                                            </Form.Control.Feedback>
                                                                                        </div>
                                                                                        <div className="col-md-12 form-group" controlid="validationCustom03">
                                                                                            <input disabled value={formData.phone} type="tel" name="name" pattern="[0-9]{8,}" title="Please enter a 8-digit phone number." className="form-control dashboard-input-box-3" placeholder="Phone" required />
                                                                                            <Form.Control.Feedback type="invalid">
                                                                                                Please enter a 8-digit phone number.
                                                                                            </Form.Control.Feedback>
                                                                                        </div>
                                                                                        <div className="col-md-12 form-group" controlid="validationCustom04">
                                                                                            <input disabled value={formData.email} type="email" className="form-control dashboard-input-box-3" name="email" placeholder="Email" required />
                                                                                            <Form.Control.Feedback type="invalid">
                                                                                                Please choose a email.
                                                                                            </Form.Control.Feedback>
                                                                                        </div>
                                                                                        <div className="col-md-12 form-group" controlid="validationCustom04">
                                                                                            <input disabled value={formData.address} type="text" className="form-control dashboard-input-box-3" name="address" placeholder="Street Address, Apt. #" required />
                                                                                            <Form.Control.Feedback type="invalid">
                                                                                                Please choose a street address.
                                                                                            </Form.Control.Feedback>
                                                                                        </div>
                                                                                        <div className="col-4 col-md-6 form-group mb-0" controlid="validationCustom01">
                                                                                            <input type="text" disabled value={formData.city} name="f-name" className="form-control dashboard-input-box-3" placeholder="City" required />
                                                                                            <Form.Control.Feedback type="invalid">
                                                                                                Please enter City
                                                                                            </Form.Control.Feedback>
                                                                                        </div>
                                                                                        <div className="col-4 col-md-3 form-group mb-0" controlid="validationCustom02">
                                                                                            <input type="text" disabled value={formData.state} name="l-name" className="form-control dashboard-input-box-3" placeholder="State" required />
                                                                                            <Form.Control.Feedback type="invalid">
                                                                                                Please enter State
                                                                                            </Form.Control.Feedback>
                                                                                        </div>
                                                                                        <div className="col-4 col-md-3 form-group mb-0" controlid="validationCustom02">
                                                                                            <input type="text" disabled value={formData.zip} name="l-name" className="form-control dashboard-input-box-3" placeholder="Zip Code" required />
                                                                                            <Form.Control.Feedback type="invalid">
                                                                                                Please enter Zip Code
                                                                                            </Form.Control.Feedback>
                                                                                        </div>
                                                                                    </div>
                                                                                </Form>
                                                                            </div>
                                                                        </Tab>

                                                                        <Tab eventKey="notes" title="Notes">
                                                                            <div className="tab-box-section notes-tab">
                                                                                <div className="form-group">
                                                                                    <textarea value={notes} onChange={(e) => setnotes(e.target.value)} className="dashboard-text-area" id="exampleFormControlTextarea1" rows="10" placeholder="Leave your note here..." ></textarea>
                                                                                    {
                                                                                        noteserror ? (
                                                                                            <div className="error-msg" style={{color:'red'}}>Please enter notes</div>
                                                                                        ) : null
                                                                                    }
                                                                                </div>
                                                                                <div className='text-center'>
                                                                                    <button className="btn btn-create" onClick={handleaddnotes} >Add Note</button>
                                                                                </div>
                                                                            </div>
                                                                            <>
                                                                                {
                                                                                    notesdata.length === 0 ? (
                                                                                        <div className="tab-box-section notes-tab mt-4">
                                                                                            <div className='no-data-img'>
                                                                                                <img src={require("../../assets/images/logo_text.png")} alt="" />
                                                                                            </div>
                                                                                            <div className="no-data-text">
                                                                                                <h3>No data Found</h3>
                                                                                            </div>
                                                                                        </div>
                                                                                    )
                                                                                        :
                                                                                        notesdata.map((item, i) => {
                                                                                            return (
                                                                                                <div className="dashboard-sec new_activity">
                                                                                                    <div className="form-box-section activity-form-box">
                                                                                                        <div className="form-list-inner">
                                                                                                            <div className="form-list-title activity-title">
                                                                                                                <div className="emp-name">
                                                                                                                    <div className="emp-light">Employee:</div>

                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div className="form-card-body-status">
                                                                                                                {item.notes}
                                                                                                            </div>
                                                                                                            <div className="form-change-date">Date: <span className="emp-bold">{item && formatDate(item.createdAt)}</span></div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            )
                                                                                        })
                                                                                }
                                                                            </>
                                                                        </Tab>
                                                                    </Tabs>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )
            }
        </>
    )
};

const formatDate = (dateString) => {
    const date = new Date(dateString);
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const day = String(date.getUTCDate()).padStart(2, '0');
    const year = String(date.getUTCFullYear()).slice(-2);
    return `${month}/${day}/${year}`;
};


export default ClubFittingUpdate;